import React from 'react'
import {FormInputComponent} from "../../../components/form/Form";
import {useSupplierFormItem} from "../providers/SupplierFormItemProvider";
import {Button, Divider, Tag} from "antd";
import FlipMove from "react-flip-move";
import SearchBrandsInput from "../../../components/form/SearchBrandsInput";
import {SearchTagsExpertise} from "../../talent-application/components/KeyClientsForm";
import ProfileBrand from "../../profiles/components/ProfileBrand";


const MAX_TAGS_COUNT = 12
const MAX_BRANDS_COUNT = 4
const MAX_LINKS_COUNT = 3
const MAX_IMAGE_ASSETS_COUNT = 10
const MAX_DOC_ASSETS_COUNT = 10

const isValidURLFormat = (string) => {
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?$/;
    return urlPattern.test(string);
}

const SupplierKeyClientForm = () => {

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing,
        yearOptions
    } = useSupplierFormItem()
    let {
        industries = [],
        skills = [],
        disciplines = [],
        brands = [],
        imgAssets = [],
        docAssets = [],
        links = [],
        ...props
    } = profileItem;

    const allTags = TB.concat(disciplines, skills, industries)
    return (
        <div className="flex flex-col">
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-5/12">
                    <FormInputComponent
                        fieldName="headline"
                        value={profileItem.headline}
                        type={'text'}
                        label="Headline"
                        maxLength={255}
                        required={true}
                        placeholder="Case Study Headline"
                        style={styles.field}
                    />
                </div>
                <div className="field px-3.5 basis-5/12">
                    <FormInputComponent
                        fieldName="year"
                        value={profileItem.year}
                        label={TB.trans('talent.client_work_form.year_label')}
                        placeholder={TB.trans('talent.client_work_form.year_placeholder')}
                        type={'select'}
                        required={true}
                        options={yearOptions}
                        style={styles.field}
                    />
                </div>
            </div>
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-8/12">
                    <FormInputComponent
                        fieldName="image_path"
                        value={profileItem.image_path}
                        label={TB.trans('talent.client_work_form.add_photo_label')}
                        type="pixie"
                        ratio="16:9"
                        width={300}
                        required={false}
                        style={styles.field}
                    />
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <FormInputComponent
                        fieldName="description"
                        value={profileItem.description}
                        label={TB.trans('talent.client_work_form.summary_paragraph_label')}
                        placeholder={TB.trans('talent.client_work_form.summary_paragraph_placeholder')}
                        type={'editor'}
                        required={false}
                        style={styles.field}
                        maxLength={10000}
                        minLength={50}
                        rows={10}
                        validation={{
                            rules: {
                                maxLength: 10000
                            },
                            errors: {
                                maxLength: TB.trans('validation.max.string', {
                                    'attribute': 'summary',
                                    'max': 10000
                                }),
                                minCharLength: TB.trans('validation.min.string', {
                                    'attribute': 'summary',
                                    'min': 50
                                })
                            }
                        }}
                    />
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field-element py-0">
                    <Divider className="mt-1 mb-2"/>
                </div>
            </div>
            <div className="field-section flex-row">
                <div className="search-brand-input field px-3.5 basis-10/12">
                    <div className={"form-group"} style={styles.field}>
                        <label className="col-form-label flex flex-row items-center gap-7">
                            <span>
                                Brands Worked With
                            </span>
                            {brands?.length > 0 && (
                                <span className={TB.mapClass("ml-auto text-xxs italic", {
                                    "opacity-7": brands?.length < MAX_BRANDS_COUNT,
                                    "text-danger font-semibold opacity-1": brands?.length === MAX_BRANDS_COUNT,
                                })}>
                                    Max ({brands?.length} / {MAX_BRANDS_COUNT})
                                </span>
                            )}
                        </label>
                        {brands?.length > 0 && (
                            <div className="items-stretch flex flex-row flex-wrap mt-5 gap-3">
                                {brands.map((brand, brandIndex) => {
                                    const brandKey = TB.slugify(`brand-${profileIndex}-${(brand.id || brand.domain || brand.name)}`)
                                    return (
                                        <ProfileBrand brand={brand} showTooltip={true} className="max-w-[140px] relative"  key={brandKey}>
                                            <div className="absolute top-2 right-2 flex flex-row items-center justify-center">
                                                <div onClick={e => {

                                                    let updatedBrands = TB.clone(brands)
                                                    const newBrandsList = updatedBrands.slice();
                                                    newBrandsList.splice(brandIndex, 1);
                                                    onModelChange({
                                                        ...profileIndex,
                                                        brands: newBrandsList
                                                    })
                                                }}
                                                     className="clickable fa fa-times-circle text-danger self-start"/>
                                            </div>

                                        </ProfileBrand>
                                    );
                                })}
                            </div>
                        )}
                        <Divider className="mt-0 mb-4"/>

                        <div className="mt-1">
                            <SearchBrandsInput
                                isDisabled={brands?.length >= MAX_BRANDS_COUNT}
                                placeholder={brands?.length < MAX_BRANDS_COUNT ? "Search for brands" : "Max brands limit reached"}
                                autoClearSearchValue={true}
                                shouldReset={true}
                                value={null}
                                disabledOptions={TB.map(brands, brand => brand.id || brand.brandId || brand.domain)}
                                onChange={(brand) => {
                                    console.log('brandchange', brand)
                                    onModelChange({
                                        ...profileItem,
                                        brands: [...(brands || []), brand]
                                    })

                                }}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field-element py-0">
                    <Divider className="mt-1 mb-2"/>
                    <FormInputComponent
                        type="hidden"
                        style={{display: 'none'}}
                        fieldName="industries"
                        value={profileItem.industries}
                    />
                    <FormInputComponent
                        type="hidden"
                        style={{display: 'none'}}
                        fieldName="brands"
                        value={profileItem.brands}
                    />
                    <FormInputComponent
                        type="hidden"
                        style={{display: 'none'}}
                        fieldName="skills"
                        value={profileItem.skills}
                    />
                    <FormInputComponent
                        type="hidden"
                        style={{display: 'none'}}
                        fieldName="disciplines"
                        value={profileItem.disciplines}
                    />
                </div>
            </div>


            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <div className={"form-group"} style={styles.field}>
                        <label className="col-form-label flex flex-row items-center gap-7">
                            <span>
                                Tags
                            </span>
                            {allTags?.length > 0 && (
                                <span className={TB.mapClass("ml-auto text-xxs italic", {
                                    "opacity-7": allTags?.length < MAX_TAGS_COUNT,
                                    "text-danger font-semibold opacity-1": allTags?.length === MAX_TAGS_COUNT,
                                })}>
                                    Max ({allTags?.length} / {MAX_TAGS_COUNT})
                                </span>
                            )}
                        </label>
                        <div className="discipline-skills-container">
                            <FlipMove typeName={null} maintainContainerHeight={true}>
                                {TB.map(allTags, (item, index) => {
                                    const colorMap = {
                                        industries: 'default',
                                        skills: 'geekblue',
                                        disciplines: 'purple'
                                    };

                                    const onPreventMouseDown = (event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                    };

                                    return (
                                        <Tag
                                            key={item.value}
                                            color={colorMap[item.type]}
                                            onMouseDown={onPreventMouseDown}
                                            closable={isEditing}
                                            onClose={() => {
                                                let change = {...profileItem};
                                                change[item.type] = TB.filter([...(change[item.type] || [])], option => parseInt(option?.id) !== parseInt(item.id))
                                                onModelChange(change)
                                            }}
                                            className="mr-3 my-1.5">
                                            {item.name}
                                        </Tag>
                                    );
                                })}
                            </FlipMove>
                        </div>
                    </div>
                </div>
            </div>
            <div className="field-section flex-row">
                <div className="field px-0 mb-2 basis-10/12">
                    <div className="px-3.5">
                        <SearchTagsExpertise
                            isDisabled={false}
                            isEditable={isEditing}
                            value={allTags}
                            maxCount={MAX_TAGS_COUNT}
                            onChange={params => {
                                console.log('params', params )
                                onModelChange({
                                    ...profileItem,
                                    ...params
                                });
                            }}/>
                    </div>
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field-element py-0">
                    <Divider className="mt-1 mb-2"/>
                </div>
            </div>


            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <div className="form-group" style={styles.field}>
                        <FormInputComponent
                            fieldName="imgAssets"
                            value={profileItem.imgAssets}
                            label="Other Key Visuals (optional)"
                            type="multi-image"
                            display_label="Key Visual"
                            accept=".jpg,.jpeg,.png,.gif,.mp4,.webm,.mov"
                            maxCount={MAX_IMAGE_ASSETS_COUNT}
                            required={false}
                        />
                    </div>
                </div>
            </div>
            <div className="field-section flex-row">
                <div className="field-element py-0">
                    <Divider className="mt-1 mb-2"/>
                </div>
            </div>


            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <div className={"form-group"} style={styles.field}>
                        <FormInputComponent
                            fieldName="docAssets"
                            value={profileItem.docAssets}
                            label="Related Documents (optional)"
                            type="multi-doc"
                            mimi="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                            display_label="Key Visual"
                            accept=".pdf,.doc,.docx,.txt,.xlsx,.xls,.csv,.ppt,.pptx"
                            maxCount={MAX_DOC_ASSETS_COUNT}
                            required={false}
                        />
                    </div>
                </div>
            </div>
            <div className="field-section flex-row">
                <div className="field-element py-0">
                    <Divider className="mt-1 mb-2"/>
                </div>
            </div>
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <div className={"form-group"} style={styles.field}>
                        <label className="col-form-label flex flex-row items-center gap-7">
                            <span>
                                Related Links (optional)
                            </span>
                            {links?.length > 0 && (
                                <span className={TB.mapClass("ml-auto text-xxs italic", {
                                    "opacity-7": links?.length < MAX_LINKS_COUNT,
                                    "text-danger font-semibold opacity-1": links?.length === MAX_LINKS_COUNT,
                                })}>
                                    Max ({links?.length} / {MAX_LINKS_COUNT})
                                </span>
                            )}
                        </label>
                        <div className="flex flex-col gap-3">
                            {TB.map(links, (link, index) => (
                                <div key={`link-${index}`} className="flex flex-row items-center gap-1.5">
                                    <i className="fa fa-link text-xxs text-gray-400"/>

                                    <a href={link} target="_blank"
                                       className="p-0 btn-link-primary underline text-xs">{link}</a>

                                    <i className="fa fa-times text-danger clickable ml-2" onClick={() => {
                                        return onModelChange({
                                            ...profileItem,
                                            links: TB.filter(links, l => l !== link)
                                        })
                                    }}/>
                                </div>
                            ))}
                            {(!links?.length || links?.length < MAX_LINKS_COUNT) && (
                                <div className="flex flex-row items-center self-stretch gap-2">
                                    <div className="flex-grow relative">
                                        <FormInputComponent
                                            key={`new-link-input-${links?.length + 1}`}
                                            fieldName="newLink"
                                            className="flex-grow"
                                            type="url"
                                            placeholder="https://example.com/newLink"
                                            label={false}
                                            value={profileItem.newLink || ""}
                                            required={false}
                                        />
                                    </div>
                                    <Button
                                        disabled={!isValidURLFormat(profileItem.newLink || "")}
                                        onClick={() => {
                                            return onModelChange({
                                                ...profileItem,
                                                newLink: "",
                                                links: [...links, profileItem.newLink]
                                            })
                                        }} type="default" className="text-xs flex flex-row gap-1.5"
                                        size="small">
                                        <i className="fa fa-plus ml-1"/>
                                        <span>Add Link</span>
                                    </Button>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SupplierKeyClientForm;
const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};